// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2n-2D","content":"styles_content__SjQ5l"};